// extracted by mini-css-extract-plugin
export default {"card":"AboutCard_card__838Ku","content":"AboutCard_content__dHFpf","icon":"AboutCard_icon__KI8fa","animate":"AboutCard_animate__C8PjR","text":"AboutCard_text__-gckF"};